import { create } from 'zustand';

interface SnackbarState {
	title: string;
	message: string;
	severity: 'success' | 'error';
	isOpen: boolean;
	showSnackbar: (title: string, message: string, severity: 'success' | 'error') => void;
	closeSnackbar: () => void;
}

export const useSnackbarStore = create<SnackbarState>((set) => ({
	message: '',
	title: '',
	severity: 'success',
	isOpen: false,
	showSnackbar: (title, message, severity) => set({ message, title, severity, isOpen: true }),
	closeSnackbar: () => set({ isOpen: false }),
}));
